import WithRender from "../../templates/ui/selectOption.html";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { v4 as uuidv4 } from "uuid";
import { i18n } from "../../i18n.js";

import Select2 from "v-select2-component";
import Vue from "vue";
import Tooltip from "../ui/Tooltip";

export default WithRender({
  components: { Select2 },
  computed: {
    ...mapGetters([
      "getSummary",
      "getMarginColor",
      "getLayoutType",
      "getHideSearchBoxInPoptext",
      "getIsPackingEnabled",
      "getSelector",
      "getShowTooltipsInPOPoptext",
      "getVueInstance",
      "getShowTooltipsInPOVPoptext",
      "getIsCimpressDefaultSelection",
      "getCimpressHiddenPageOptions",
      "getIsTooltipsActive"
    ]),
    name: function () {
      return this.propsData.name;
    },
    options: function () {
      return this.propsData.values.filter(el => {
        return !el.disabled;
      });
    },
    tooltip: function () {
      return this.getShowTooltipsInPOPoptext && this.propsData.tooltip;
    },
    settings: function () {
      var multiple = 0;
      if (this.propsData.type && this.propsData.type == "multiple") {
        multiple = 1;
      }
      var hideOptions = {};
      if (this.getHideSearchBoxInPoptext) {
        hideOptions = { minimumResultsForSearch: -1 };
      }
      return { multiple, ...hideOptions, templateResult: this.getTemplate };
    },
    value: {
      get: function () {
        return this.propsData.type && this.propsData.type == "multiple"
          ? this.propsData.selected
          : this.propsData.selected[0];
      },
      set: function (newValue) {
        if (this.propsData.code === "paper" && this.getIsPackingEnabled) {
          this.$swal({
            text: i18n.t(
              "If you change the paper, you will need to upload the artwork again!"
            ),
            icon: "warning",
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: i18n.t("Cancel"),
            confirmButtonText: i18n.t("Ok")
          }).then(userAction => {
            if (userAction.isConfirmed) {
              this.afterChangePageOption(newValue);
              const event = new Event("pqMatrix_paperChanged");
              window.document.dispatchEvent(event);
            } else {
              this.afterChangePageOption(this.value);
            }
          });
        } else {
          this.afterChangePageOption(newValue);
        }
      }
    },
    showColorPickerForOption: function () {
      return (
        this.value === "oie_margin_type_monochromatic" &&
        this.getLayoutType === "image_editor"
      );
    },
    getId: function () {
      return this.getSelector + "_" + this.selectId + "_" + uuidv4();
    },
    code: function () {
      return this.propsData.code;
    },
    isHiddenInFrontend: function () {
      return this.getCimpressHiddenPageOptions.indexOf(this.code) > -1;
    }
  },
  methods: {
    ...mapActions(["setPageOption", "setCimpressHiddenPageOptions"]),
    ...mapMutations(["changeMarginColor"]),
    hidePageOptionInFrontend: function (event) {
      let hiddenPageOptions = this.getCimpressHiddenPageOptions;
      if (event.target.checked) {
        if (hiddenPageOptions.indexOf(this.code) == -1) {
          hiddenPageOptions.push(this.code);
        }
      } else {
        hiddenPageOptions = hiddenPageOptions.filter(val => val !== this.code);
      }
      this.setCimpressHiddenPageOptions(hiddenPageOptions);
    },
    proccessMarginColor: function (event) {
      this.changeMarginColor(event.target.value);
    },
    afterChangePageOption: function (newValue) {
      this.setPageOption({
        value: newValue,
        layout: false,
        option: this.propsData.code,
        optionType: this.optionType
      });
    },
    getTemplate: function (state, container) {
      if (!$(container).hasClass("tooltipAddedTemplate")) {
        $(container).addClass("tooltipAddedTemplate");
        if (state.tooltip) {
          $(container).data("matrix_tooltip_id", state.id);
        }
      }

      return state.text;
    },
    getPOValueTooltip: function (id) {
      for (var idx in this.propsData.values) {
        if (this.propsData.values[idx].id == id) {
          return this.propsData.values[idx].tooltip;
        }
      }
      return null;
    }
  },
  mounted: function () {
    if (!this.getIsTooltipsActive || !this.getShowTooltipsInPOVPoptext) {
      return;
    }
    const that = this;
    jQuery("#" + this.getId).on("select2:open", function (params) {
      setTimeout(function () {
        var id = jQuery("#select2-" + that.getId + "-results");
        if (id.length) {
          id = id[0];
          for (var i in id.children) {
            var item = id.children[i];
            if (typeof item == "object") {
              if (!jQuery(item).hasClass("tooltipAdded")) {
                var tooltipId = jQuery(item).data("matrix_tooltip_id");
                if (tooltipId) {
                  var tooltip = that.getPOValueTooltip(tooltipId);
                  if (tooltip) {
                    const TooltipClass = Vue.extend(Tooltip);
                    const buttonInstance = new TooltipClass({
                      store: that.getVueInstance.$store,
                      propsData: {
                        tooltip
                      }
                    });
                    buttonInstance.$mount();
                    jQuery(item).append(buttonInstance.$el);
                  }
                }
              }
            }
          }
        }
      }, 100);
    });
  },
  props: ["propsData", "optionType", "selectId"]
});
